<template>
	<header
		class="top-bar"
		:class="{'docked': isSearchBarDocked}"
	>
		<div class="top-bar__left">
			<LangSelector />
		</div>
		<div class="top-bar__right">
			<button
				id="startTutorial"
				v-tippy="{placement:'bottom', popperOptions: {strategy: 'fixed'}}"
				class="top-bar__button"
				:data-tippy-content="$t('topBar.startTutorial')"
				@click="startTutorial"
			>
				<svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'top-bar__icon'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" d="M16 8A8 8 0 110 8a8 8 0 0116 0zM5.496 6.033a.237.237 0 01-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 01-.25.25h-.81a.25.25 0 01-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"/></svg>
			</button>
			<KoFi />
			<label
				id="darkmode-label"
				ref="darkmode"
				v-tippy="{placement:'bottom', popperOptions: {strategy: 'fixed'}}"
				for="darkMode"
				class="top-bar__label"
				:class="{'checked': isDarkModeOn}"
				:data-tippy-content="$t('topBar.darkMode')"
			>
				<input
					id="darkMode"
					v-model="isDarkModeOn"
					type="checkbox"
					name="darkMode"
					class="sr-only"
				>

				<transition
					name="rise"
					mode="out-in"
				>
					<!-- icon if darkMode is on -->
					<svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" v-if="isDarkModeOn" v-bind:key="'on'" v-bind:svg-inline="''" v-bind:class="'top-bar__icon'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" d="M14.53 10.53a7 7 0 01-9.058-9.058A7.003 7.003 0 008 15a7.002 7.002 0 006.53-4.47z"/></svg>
					<svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:key="'off'" v-bind:svg-inline="''" v-bind:class="'top-bar__icon'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 8a4 4 0 11-8 0 4 4 0 018 0z"/><path fill-rule="evenodd" d="M8 0a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2A.5.5 0 018 0zm0 13a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2A.5.5 0 018 13zm8-5a.5.5 0 01-.5.5h-2a.5.5 0 010-1h2a.5.5 0 01.5.5zM3 8a.5.5 0 01-.5.5h-2a.5.5 0 010-1h2A.5.5 0 013 8zm10.657-5.657a.5.5 0 010 .707l-1.414 1.415a.5.5 0 11-.707-.708l1.414-1.414a.5.5 0 01.707 0zm-9.193 9.193a.5.5 0 010 .707L3.05 13.657a.5.5 0 01-.707-.707l1.414-1.414a.5.5 0 01.707 0zm9.193 2.121a.5.5 0 01-.707 0l-1.414-1.414a.5.5 0 01.707-.707l1.414 1.414a.5.5 0 010 .707zM4.464 4.465a.5.5 0 01-.707 0L2.343 3.05a.5.5 0 11.707-.707l1.414 1.414a.5.5 0 010 .708z"/></svg>
				</transition>

				<div
					v-if="isDarkModeOn"
					key="on"
					class="top-bar__horizon on"
				/>
				<div
					v-else
					key="off"
					class="top-bar__horizon off"
				/>

				<span class="sr-only">{{ $t('topBar.darkMode') }}</span>
			</label>
		</div>
	</header>
</template>

<script lang="js">
import LangSelector from '@/components/LangSelector';
import KoFi from '@/components/KoFi';

export default {
	name: 'TopBar',
	components: {
		LangSelector,
		KoFi
	},
	props: {
		isSearchBarDocked: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	data () {
		return {
			isMenuOpen: false
		};
	},
	computed: {
		isDarkModeOn: {
			get() {
				return this.$store.getters.isDarkModeOn;
			},
			set(newValue) {
				this.$store.commit('SET_DARK_MODE', newValue);
			}
		}
	},
	methods: {
		toggleMenu(state) {
			if (typeof state !== 'undefined' && !(state instanceof Event)) {
				this.isMenuOpen = state;
			}
			else {
				this.isMenuOpen = !this.isMenuOpen;
			}
		},
		startTutorial() {
			this.$store.commit('SET_TUTORIAL_COMPLETION', false);
		}
	}
};


</script>

<style lang="scss">
  .top-bar {
		background: var(--bg-gradient);
		position: fixed;
		width: 100%;
		top: 0;
		height: 3em;
		z-index: 15;
		display: flex;
		align-items: center;
		box-shadow: 0 0 5px #0003;
		display: flex;
		padding: 0 2em;
		transition: background-image 300ms ease-in-out;

		&__left,
		&__right{
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: .25em;

			transition: opacity 300ms ease-in-out;
			@media screen and (max-width: 68em) {
				@at-root .docked & {
					opacity: 0;
				}
			}
		}

		&__left{
			margin-right: auto;
		}

		&__label,
		&__button {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: .5em;
			border-radius: 5px;
			cursor: pointer;
			transition: 300ms ease-in-out;
			transition-property: border-color, opacity;
			border: 1px solid transparent;
			background-color: #0000;

			&:focus,
			&:hover {
				border-color: var(--text);
				outline: none;
			}
		}

		&__horizon {
			background-color: var(--text);
			height: 2px;
			width: 0;
			border-radius: 1.5px;
			margin-bottom: -2px;

			&.on, &.off {
				animation: grow 1250ms 1 ease-out;

				@keyframes grow {
					0% {
						width: 0%;
					}
					20% {
						width: 150%;
					}
					80% {
						width: 150%;
					}
					100% {
						width: 0%;
					}
				}
			}
		}

		&__icon {
			width: 1.25em;
			height: 1.25em;
			color: var(--text);

		}
		.rise-enter-active,
		.rise-leave-active {
			transition: 250ms 250ms ease-out;
			transition-property: transform, clip-path;
		}

		.rise-enter {
			transform: translateY(100%);
			clip-path: inset(0 0 100% 0);
		}
		.rise-enter-to{
			transform: translateY(0);
			clip-path: inset(0 0 0 0);
		}

		.rise-leave {
			transform: translateY(0);
			clip-path: inset(0 0 0 0);
		}
		.rise-leave-to {
			transform: translateY(100%);
			clip-path: inset(0 0 100% 0);
		}
	}
</style>
